import { useState } from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { Mail, Lock, ShieldCheck, ArrowRight } from "lucide-react";
import { Input } from "@/components/ui/input";

export const BackofficeLogin = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) return toast.error("Preencha e-mail e senha.");
    setLoading(true);
    const ok = await onLogin(email.trim(), password);
    setLoading(false);
    if (ok) toast.success("Bem-vindo ao Backoffice VeloClin");
    else toast.error("Credenciais inválidas", { description: "Verifique o e-mail e a senha." });
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-900 px-5 py-10">
      <motion.div initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="w-full max-w-md">
        <div className="rounded-3xl border border-slate-700/40 bg-white p-8 shadow-2xl">
          <div className="flex flex-col items-center text-center">
            <img src="/veloclin-logo.png" alt="VeloClin" data-testid="brand-logo" className="h-20 w-auto" />
            <span className="mt-3 inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-slate-600">
              <ShieldCheck className="h-3 w-3" /> Acesso Restrito · Equipe Interna
            </span>
            <h1 className="mt-4 font-heading text-2xl font-extrabold tracking-tight text-slate-900">VeloClin Backoffice</h1>
            <p className="mt-1 text-sm text-slate-500">Painel de controle de fundadores e vendas</p>
          </div>

          <form onSubmit={submit} className="mt-7 space-y-4">
            <div>
              <label className="text-xs font-semibold text-slate-600">E-mail Corporativo</label>
              <div className="relative mt-1.5">
                <Mail className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
                <Input data-testid="bo-login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="voce@veloclin.ai" className="border-slate-200 pl-9 focus-visible:ring-slate-900" />
              </div>
            </div>
            <div>
              <label className="text-xs font-semibold text-slate-600">Senha</label>
              <div className="relative mt-1.5">
                <Lock className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
                <Input data-testid="bo-login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="border-slate-200 pl-9 focus-visible:ring-slate-900" />
              </div>
            </div>
            <button data-testid="bo-login-submit" type="submit" disabled={loading} className="group flex w-full items-center justify-center gap-2 rounded-xl bg-slate-900 py-3.5 text-sm font-bold text-white shadow-lg transition-colors hover:bg-slate-800 disabled:opacity-60">
              {loading ? "Acessando..." : "Acessar Backoffice"}
              {!loading && <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />}
            </button>
          </form>
          <p className="mt-5 text-center text-[11px] text-slate-400">Ambiente exclusivo. Todo acesso é registrado.</p>
        </div>
      </motion.div>
    </div>
  );
};
